import { Component, OnInit } from '@angular/core';
import { AppState, selectAuthState, selectDoctorState, selectPatientState } from '../../../store/app.states';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { GetPendings } from '../../../store/actions/patient.actions';
import { AuthService } from '../../../services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { GdprDialogComponent } from '../../user-actions/gdpr-dialog/gdpr-dialog.component';
import { LogOut } from '../../../store/actions/auth.actions';
import { Router } from '@angular/router';
import { DoctorService } from '../../../services/doctor.service';
import { PatientService } from 'src/app/services/patient.service';
import { Announcement } from 'src/app/model/announcement/Announcement';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css']
})
export class LandingComponent implements OnInit {

  getAuthState: Observable<any>;
  customState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  message;
  title = 'Benvenuto';
  allCPatients: number;
  allAPatients: number;
  allUCPatients: number;

  //announcement per patient
  announcement: Announcement;
  categoryPatient: string;

  constructor(private store: Store<AppState>,
    private dialog: MatDialog,
    private router: Router,
    private authService: AuthService,
    private doctorService: DoctorService) {
    this.getAuthState = this.store.select(selectAuthState);
  }

  ngOnInit(): void {
    this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;
    });

    if (this.user.role === 'DOTTORE') {
      this.customState = this.store.select(selectDoctorState);
    }

    if (this.user.role === 'PAZIENTE') {
      let enabled = false;
      this.authService.isPatientEnabled(this.user).subscribe(res => {

        if (res.status === 200) {
          localStorage.setItem('enabled', JSON.stringify(res.body));
          enabled = res.body;
          console.log('ENABLED?', enabled);
          if (!enabled) {
            setTimeout(() => {
              this.openGDPRDialog();
            }, 1000);
          } else {
            localStorage.removeItem('enabled');
          }
        }
      },
        error => {
          console.error(error, 'Failed request');
        }
      );

      this.customState = this.store.select(selectPatientState);
      this.store.dispatch(new GetPendings());
      this.getCategory();

    }

  }

  openGDPRDialog(): void {
    const dialogRef = this.dialog.open(GdprDialogComponent, {
      width: '1000px',
      height: '700px',
      data: this.user.role,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      let response: string;
      if (result) {
        response = 'true';
      } else {
        response = 'false';
      }
      this.authService.enablePatient(this.user, response);
      if (!result) {
        this.store.dispatch(new LogOut());
      }
    });
  }

  goToContactCenter() {
    this.router.navigateByUrl('/contact-center/');
  }

  getCategory() {
    this.doctorService.getCategoryPatient(this.user.ssn).subscribe(received => {
      this.categoryPatient = received;
      if (this.categoryPatient === "TELEMEDICINA") this.getLastAnnouncement();
    }
      , error => {
        if (error.status === 500) {
          // nel caso di errore 500 vuol dire che è scaduto il token ma noi non ci siamo accorti
          localStorage.setItem('expirationTime', '0');
          console.log('sessione scaduta');
          location.reload();
        }
        // this.openErrorDialog('Il messaggio non è stato mandato per un errore. Se il problema persiste ci contatti via e-mail');
      });
  }

  getLastAnnouncement() {
    this.doctorService.getLastAnnouncement().subscribe(received => {
      this.announcement = received;
      console.log(this.announcement);
      this.announcement.giorno = (new Date(this.announcement.date).getDate());
      this.announcement.mese = (new Date(this.announcement.date).getMonth() + 1);
      this.announcement.anno = (new Date(this.announcement.date).getFullYear());
    }
      , error => {
        if (error.status === 500) {
          // nel caso di errore 500 vuol dire che è scaduto il token ma noi non ci siamo accorti
          localStorage.setItem('expirationTime', '0');
          console.log('sessione scaduta');
          location.reload();
        }
        // this.openErrorDialog('Il messaggio non è stato mandato per un errore. Se il problema persiste ci contatti via e-mail');
      });
  }
}
